var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.event && _vm.event.id
    ? _c("queueton-resource-status", {
        attrs: {
          "resource-id": _vm.event.id,
          resource: "event",
          "post-processing": _vm.getEvent,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (queueResource) {
                return [
                  _c("div", { staticClass: "w-full md:pl-10 md:w-3/4" }, [
                    _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
                      _vm._v("Admin Settings"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-12" }, [
                      _c(
                        "label",
                        { ref: "festival", attrs: { for: "festival" } },
                        [
                          _vm._v("\n              Select Event Calendar "),
                          _c("span", { staticClass: "text-red" }, [
                            _vm._v("*"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.festival_id,
                              expression: "form.festival_id",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: { id: "festival", name: "festival" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.form,
                                "festival_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "" },
                              domProps: { value: null },
                            },
                            [_vm._v("Select an event calendar")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.currentFestivals, function (festival) {
                            return _c(
                              "option",
                              {
                                key: festival.id,
                                domProps: {
                                  value: festival.id,
                                  selected:
                                    _vm.event.festival.id == festival.id,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(festival.title) +
                                    " " +
                                    _vm._s(festival.datesTitle)
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.errors.has("festival")
                        ? _c(
                            "span",
                            { staticClass: "error text-error-red text-lg" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.errors
                                      .first("festival")
                                      .replaceAll("festival", "event calendar")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.hasThemes
                      ? _c("div", { staticClass: "mb-12" }, [
                          _c("label", { attrs: { for: "theme" } }, [
                            _vm._v(
                              "\n          Select Calendar Theme\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "group__checkbox" }, [
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap select-box" },
                              [
                                _vm._l(_vm.themes, function (theme) {
                                  return [
                                    _c(
                                      "label",
                                      {
                                        key: theme.id,
                                        staticClass:
                                          "w-full text-base font-normal md:w-1/2 md:pr-3",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.themes,
                                              expression: "form.themes",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: theme.id,
                                            checked: Array.isArray(
                                              _vm.form.themes
                                            )
                                              ? _vm._i(
                                                  _vm.form.themes,
                                                  theme.id
                                                ) > -1
                                              : _vm.form.themes,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.form.themes,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = theme.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.form,
                                                      "themes",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.form,
                                                      "themes",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.form,
                                                  "themes",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass:
                                            "inline-block mr-2 check",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(theme.title) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", [_vm._v("\n        Publishing\n      ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4 group__checkbox" }, [
                      _c("div", { staticClass: "select-box" }, [
                        _c(
                          "label",
                          {
                            staticClass: "text-base font-normal",
                            attrs: { for: "published" },
                          },
                          [
                            queueResource.isProcessing
                              ? [
                                  _c("input", {
                                    staticClass: "mr-3",
                                    attrs: { type: "checkbox", disabled: true },
                                    domProps: { checked: _vm.form.published },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "check inline-block mr-2",
                                  }),
                                  _vm._v(" "),
                                  _vm.form.published
                                    ? [
                                        _vm._v(
                                          "\n                Publishing...\n              "
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                Unpublishing...\n              "
                                        ),
                                      ],
                                ]
                              : [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.published,
                                        expression: "form.published",
                                      },
                                    ],
                                    staticClass: "mr-3",
                                    attrs: {
                                      type: "checkbox",
                                      id: "published",
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.form.published)
                                        ? _vm._i(_vm.form.published, null) > -1
                                        : _vm.form.published,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.form.published,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.form,
                                                "published",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.form,
                                                "published",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.form, "published", $$c)
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "check inline-block mr-2",
                                  }),
                                  _vm._v(" Published\n            "),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4 group__checkbox" }, [
                      _c("div", { staticClass: "select-box" }, [
                        _c(
                          "label",
                          {
                            staticClass: "text-base font-normal",
                            attrs: { for: "third-party" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.allowThirdParty,
                                  expression: "form.allowThirdParty",
                                },
                              ],
                              staticClass: "mr-3",
                              attrs: { type: "checkbox", id: "third-party" },
                              domProps: {
                                checked: Array.isArray(_vm.form.allowThirdParty)
                                  ? _vm._i(_vm.form.allowThirdParty, null) > -1
                                  : _vm.form.allowThirdParty,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.form.allowThirdParty,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "allowThirdParty",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "allowThirdParty",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form, "allowThirdParty", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "check inline-block mr-2",
                            }),
                            _vm._v(" Allow third party ticketing\n          "),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4 group__checkbox" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "my-6 mb-12 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button mr-4",
                          class: {
                            "opacity-50 cursor-not-allowed":
                              _vm.saving || queueResource.isProcessing,
                          },
                          attrs: {
                            disabled: _vm.saving || queueResource.isProcessing,
                          },
                          on: { click: _vm.save },
                        },
                        [
                          _vm.saving
                            ? [_vm._v("Processing...")]
                            : [_vm._v("Save")],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          class: {
                            "opacity-50 cursor-not-allowed":
                              _vm.saving || queueResource.isProcessing,
                          },
                          attrs: {
                            disabled: _vm.saving || queueResource.isProcessing,
                          },
                          on: { click: _vm.saveNext },
                        },
                        [_vm._v("\n          Save & Next\n        ")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pt-8 border-t border-rose-600" },
                      [
                        _c("p", { staticClass: "mb-6" }, [
                          _vm._v(
                            "Deleting an event will unpublish the event and archive so it does not show."
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button bg-red-dark",
                            on: { click: _vm.deleteEvent },
                          },
                          [_vm._v("\n          Delete\n        ")]
                        ),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          false,
          4020518186
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }